import React from 'react';
import MobileChartCard from './components/MobileChartCard';

const MobileChart  = () => {
        return <MobileChartCard />
}

export default React.memo(MobileChart);
